<template>
  <IconWrapper name="show" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0028 9.67969C10.7198 9.67969 9.67578 10.7207 9.67578 11.9997C9.67578 13.2847 10.7198 14.3297 12.0028 14.3297C13.2858 14.3297 14.3288 13.2847 14.3288 11.9997C14.3288 10.7207 13.2858 9.67969 12.0028 9.67969Z"
        fill="#1B1B1E"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0028 15.8294C9.89276 15.8294 8.17576 14.1114 8.17576 11.9994C8.17576 9.89244 9.89276 8.17944 12.0028 8.17944C14.1128 8.17944 15.8288 9.89244 15.8288 11.9994C15.8288 14.1114 14.1128 15.8294 12.0028 15.8294ZM21.4598 11.8024C19.4668 7.16644 15.9298 4.39844 11.9978 4.39844C8.06776 4.39844 4.53276 7.16644 2.54076 11.8024C2.48576 11.9284 2.48576 12.0704 2.54076 12.1964C4.53176 16.8304 8.06676 19.5984 11.9968 19.6004H12.0028C15.9328 19.5984 19.4678 16.8304 21.4598 12.1964C21.5138 12.0704 21.5138 11.9284 21.4598 11.8024Z"
        fill="#1B1B1E"
      ></path>
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
